import { render } from "./PaginatedTable.vue?vue&type=template&id=29cfa8a2&scoped=true"
import script from "./PaginatedTable.vue?vue&type=script&lang=js"
export * from "./PaginatedTable.vue?vue&type=script&lang=js"

import "./PaginatedTable.vue?vue&type=style&index=0&id=29cfa8a2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cfa8a2"]])

export default __exports__